import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const Authenticating = () => {
  return (
    <div
      style={{ height: "calc(100vh - 82px - 35px)" }}
      className="d-flex justify-content-center align-items-center"
    >
      <div style={{ maxWidth: "100%", width: "30%", height: "30%" }}>
        <div className="row p-0 h-100 w-100 justify-content-center align-items-center">
          <div className="row p-0 w-100 justify-content-center align-items-center">
            <AccessTimeIcon style={{ fontSize: 90 }} />
            <div style={{ textAlign: "center" }}>
              Authenticating User
              <br />
              Please wait while we attempt to authenticate your access.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Authenticating;
